<template>
  <el-dialog
    :visible="visible"
    title="方案修改"
    class="combo-dialog"
    @close="onClose"
    :fullscreen="true"
  >
    <el-tabs v-model="searchData.comboType">
      <el-tab-pane
        v-for="status in tabs"
        :label="status.name"
        :name="status.value.toString()"
        :key="status.value"
      />
    </el-tabs>
    <!-- <div
      v-if="
        searchData.comboType === dict.EnumComboType.A.toString() &&
        hasRewardComboTab
      "
      class="search-form"
    >
      线路选择：
      <el-select v-model="searchData.comboRoute" size="small">
        <el-option
          v-for="item in dict.ComboRouteList"
          :label="item.name"
          :value="item.value"
          :key="item.value"
        />
      </el-select>
    </div> -->
    <div class="dialog-save">
      <el-radio-group
        v-model="showRetailPrice"
        size="small"
        class="retail-toggle"
      >
        <el-radio-button :label="true">显示零售价</el-radio-button>
        <el-radio-button :label="false">隐藏零售价</el-radio-button>
      </el-radio-group>
      <el-button size="small" type="primary" @click="onSubmit">保 存</el-button>
    </div>
    <div class="combo-body">
      <el-empty
        v-if="list.length === 0 && !listRequestInFlight"
        class="combo-empty"
        description="暂无记录"
      />
      <div v-else-if="list.length > 0" class="grade-list">
        <div
          v-for="(item, index) in groupedList"
          :key="item.grade.value"
          class="grade-group"
        >
          <div class="grade-name">{{ item.grade.name }}</div>
          <div class="combo-list">
            <div class="divider" v-if="index > 0" />
            <combo-card
              v-for="combo in item.list"
              :value="combo"
              :checked="form.comboId === combo.comboId"
              :showRetailPrice="showRetailPrice"
              :salePrice="salePrice"
              @checkedChange="onCheckedChange(combo.comboId)"
            />
          </div>
        </div>
      </div>
      <el-form
        ref="form"
        :model="form"
        label-width="50px"
        inline
        v-if="searchData.comboType == dict.EnumComboType.B"
      >
        <!-- <el-form-item label="备注" style="margin-top: 30px">
          <el-input v-model="form.remark" placeholder="请输入" />
        </el-form-item> -->
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import {
  ComboGradeList,
  EnumComboType,
  ComboGradeToColorMap,
  ComboTypeList,
  EnumComboRoute,
  ComboRouteList,
} from "@/enum/dict/index.js";

import ComboCard from "./combo-card.vue";
import { getStoreComboList, editStoreComboList } from "../api.js";

export default {
  name: "EditCombo",
  components: { ComboCard },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    orderNo: {
      type: String,
      required: false,
      default: null,
    },
    comboId: {
      type: Number,
      required: false,
      default: null,
    },
    comboRoute: {
      type: Number,
      required: false,
      default: EnumComboRoute.ROUTE_1,
    },
  },
  data() {
    return {
      searchData: {
        comboType: EnumComboType.A.toString(),
      },
      form: {
        remark: undefined,
        comboId: undefined,
      },
      list: [],
      comboDataMap: {},
      enableComboTypeList: [],
      /** 是否展示零售价（默认隐藏，存在不可选方案时自动置为显示）*/
      showRetailPrice: false,
      /** 零售价*/
      salePrice: "",
      /** 拉列表期间不展示 el-empty，避免清空 list 与全屏 loading 之间闪「暂无记录」 */
      listRequestInFlight: false,
      dict: {
        ComboGradeList,
        EnumComboType,
        ComboGradeToColorMap,
        ComboTypeList,
        EnumComboRoute,
        ComboRouteList,
      },
    };
  },
  computed: {
    tabs() {
      return this.dict.ComboTypeList.filter((item) =>
        this.enableComboTypeList.includes(item.value.toString()),
      );
    },
    groupedList() {
      let count = 0;

      return this.dict.ComboGradeList.map((grade) => {
        return {
          list: this.list
            .filter((combo) => {
              return grade.value === combo.comboGrade;
            })
            .map((combo) => {
              combo.index = ++count;
              return combo;
            }),
          grade,
        };
      }).filter((grade) => {
        return grade.list.length > 0;
      });
    },
  },
  watch: {
    visible(val) {
      // 不用 @opened：opened 在动画结束后才触发，此前仍保留上次 list，会「先闪旧数据再刷新」
      if (val) {
        this.prepareOpen();
      }
    },
    "searchData.comboType"(newVal, oldVal) {
      this.updateListByTab();
    },
  },
  methods: {
    onCheckedChange(id) {
      this.form.comboId = id;
    },
    prepareOpen() {
      console.log("prepareOpen",this);
      this.listRequestInFlight = true;
      this.$set(this, "searchData", this.$options.data().searchData);
      this.$set(this, "form", this.$options.data().form);
      this.$set(this, "list", []);
      this.$set(this, "comboDataMap", {});
      this.$set(this, "enableComboTypeList", []);
      this.salePrice = "";

      this.form.comboId = this.comboId;
      this.searchData.comboType = this.comboRoute == EnumComboRoute.ROUTE_2 ? EnumComboType.B.toString() : EnumComboType.A.toString();

      this.getList();
    },
    updateListByTab() {
      this.list = this.comboDataMap[this.searchData.comboType] || [];
      // 零售价默认展示规则（按当前 tab）：全部方案可选时默认隐藏；存在不可选方案时默认显示
      this.showRetailPrice = this.list.some(
        (item) => item.selectable === false,
      );
    },
    async getList() {
      this.listRequestInFlight = true;
      try {
        const res = await getStoreComboList({
          orderNo: this.orderNo,
          comboRoute:
            this.searchData.comboType === this.dict.EnumComboType.A.toString()
              ? this.searchData.comboRoute
              : undefined,
        });

        const enableComboTypeList = (res.enableComboTypeList || []).map((item) =>
          item.toString(),
        );
        this.enableComboTypeList = enableComboTypeList;

        this.comboDataMap = {
          [this.dict.EnumComboType.A.toString()]: res.normalComboList || [],
          [this.dict.EnumComboType.B.toString()]: res.rewardComboList || [],
        };
        this.salePrice = res.salePrice;

        if (!enableComboTypeList.includes(this.searchData.comboType)) {
          this.searchData.comboType =
            enableComboTypeList[0] || this.dict.EnumComboType.A.toString();
        }

        this.updateListByTab();

        const existComboId = this.list.find((item) => item.comboId === this.comboId);
        this.form.comboId = existComboId ? this.comboId : null;
      } finally {
        this.listRequestInFlight = false;
      }
    },
    onClose() {
      this.listRequestInFlight = false;
      this.$emit("update:visible", false);
    },
    async onSubmit() {
      const combo = this.list.find(
        (item) => item.comboId === this.form.comboId,
      );

      if (!combo) {
        this.$message.error("请选择方案");

        return;
      }

      await this.$confirm(
        `是否确认 <strong>${combo.comboName}</strong> 为新方案？`,
        {
          dangerouslyUseHTMLString: true,
        },
      );

      await editStoreComboList({
        orderNo: this.orderNo,
        comboTab: this.searchData.comboType,
        comboId: this.form.comboId,
        remark:
          this.searchData.comboType == EnumComboType.B
            ? this.form.remark
            : null,
      });

      this.$message({
        type: "success",
        message: "操作成功",
      });

      this.onClose();

      localStorage.setItem("is_update_period", "true");

      this.$emit("refresh");
    },
  },
};
</script>
<style scoped lang="scss">
.combo-dialog {
  /deep/ {
    .el-dialog {
      margin-bottom: 0px !important;
    }
  }
}

.header-search {
  .search-form-item {
    width: 180px;

    /deep/ {
      input {
        text-align: left;
      }
    }
  }
}

.combo-body {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 5vh - 140px);

  .combo-empty {
    padding: 48px 0;
    flex: 1;
  }

  .grade-list {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    flex: 1;
    max-height: 100%;
  }
}

.grade-group {
  display: flex;
  align-items: center;
  gap: 10px;

  .grade-name {
    font-size: 16px;
    font-weight: bold;
  }

  .combo-list {
    position: relative;
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    row-gap: 30px;
    column-gap: 10px;
    padding: 30px 10px;
    background-color: #ddd;

    .divider {
      position: absolute;
      top: -15px;
      width: 100%;
      border-top: 1px dashed #000;
    }
  }
}

.empty-grade-group {
  width: 100px;
  height: 34px;
  border-radius: 6px;
}
.dialog-save {
  position: absolute;
  right: 20px;
  top: 65px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.retail-toggle {
  /deep/ {
    display: inline-flex;
    align-items: center;
    padding: 3px;
    background-color: #f0f2f5;
    border-radius: 999px;

    .el-radio-button__inner {
      padding: 0 16px;
      line-height: 26px;
      border: none;
      border-radius: 999px;
      background-color: transparent;
      color: #909399;
      font-weight: 500;
      box-shadow: none !important;
      transition: all 0.25s ease;

      &:hover {
        color: #409eff;
      }
    }

    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      background: linear-gradient(135deg, #409eff 0%, #2f8df5 100%);
      color: #fff;
      font-weight: 600;
      box-shadow: 0 2px 6px rgba(64, 158, 255, 0.35);
    }
  }
}

.search-form {
  border-bottom: 1px solid #ccc;
  margin-bottom: 15px;
  padding-bottom: 15px;
}
</style>
